import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme, height }) => ({
  width: "100%",
  height: height ? height : "100%",
  [theme.breakpoints.down("sm")]: {
    height: "36px",
  },
  backgroundColor: theme.palette.custom.custom,
  color: theme.palette.custom.lightBack,
  border: theme.borders.default,
  borderRadius: theme.borderRadius.radius.wallet,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
export const StyledBoxImg = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "15px",
  left: "39px",
  [theme.breakpoints.down("sm")]: {
    top: "9px",
    left: "30px",
  },
  [theme.breakpoints.down("xs")]: {
    top: "8px",
    left: "16px",
  },
}));
export const StyledBoxMain = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  cursor: "pointer",
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
}));
